/**
 * @generated SignedSource<<faf1cd37abebe7d467e097603d22e9f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetSignalOverviewInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  teamIds: ReadonlyArray<string>;
};
export type WASignalOverviewMutation$variables = {
  input: CreateWidgetSignalOverviewInput;
  storecastId: string;
};
export type WASignalOverviewMutation$data = {
  readonly dashboard: {
    readonly createWidgetSignalOverview: {
      readonly id: string;
    };
  };
};
export type WASignalOverviewMutation = {
  response: WASignalOverviewMutation$data;
  variables: WASignalOverviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetSignalOverview",
        "kind": "LinkedField",
        "name": "createWidgetSignalOverview",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WASignalOverviewMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WASignalOverviewMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0a0ae33f0fc06a759611fa7e158762dd",
    "id": null,
    "metadata": {},
    "name": "WASignalOverviewMutation",
    "operationKind": "mutation",
    "text": "mutation WASignalOverviewMutation(\n  $storecastId: ID!\n  $input: CreateWidgetSignalOverviewInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetSignalOverview(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac348380d6cd300b847f9ece6ced77b8";

export default node;
